import { Link } from "react-router-dom";
import { Sparkles, ArrowRight } from "lucide-react";
import { toast } from "sonner";
import { useI18n } from "@/i18n/I18nContext";

export default function MarketingFooter() {
  const { t, lang } = useI18n();
  const submit = (e) => {
    e.preventDefault();
    toast.success(t.footer.subscribed);
    e.target.reset();
  };
  return (
    <footer className="bg-[#2C3E35] text-[#FDFBF9]">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 pt-20 pb-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 pb-16 border-b border-[#FDFBF9]/10">
          <div className="lg:col-span-5">
            <div className="flex items-center gap-2.5 mb-5">
              <img src="/bellaos-logo.png" alt="BellaOS" className="h-10 w-10 object-contain" />
              <span className="font-display font-extrabold text-xl tracking-tight">BellaOS</span>
            </div>
            <p className="text-[#FDFBF9]/70 max-w-sm leading-relaxed">{t.footer.tagline}</p>
            <form onSubmit={submit} className="mt-7 flex max-w-sm gap-2">
              <input required type="email" placeholder={t.footer.newsletter} data-testid="footer-newsletter-input"
                className="flex-1 px-4 py-2.5 rounded-full bg-[#FDFBF9]/10 border border-[#FDFBF9]/15 text-sm placeholder:text-[#FDFBF9]/40 outline-none focus:border-[#D4AF37]/50 transition" />
              <button data-testid="footer-newsletter-submit" className="px-4 rounded-full bg-[#D4AF37] text-[#2C3E35] hover:bg-[#e0bd4a] transition-colors">
                <ArrowRight size={18} />
              </button>
            </form>
          </div>
          <div className="lg:col-span-7 grid grid-cols-2 sm:grid-cols-3 gap-8">
            <div>
              <div className="text-xs uppercase tracking-[0.2em] text-[#D4AF37] mb-4 font-bold">{t.footer.product}</div>
              <ul className="space-y-2.5 text-sm text-[#FDFBF9]/70">
                <li><Link to="/#ai" className="hover:text-white transition-colors">{t.nav.ai}</Link></li>
                <li><Link to="/promotions" className="hover:text-white transition-colors">{t.nav.promotions}</Link></li>
                <li><Link to="/pricing" className="hover:text-white transition-colors">{t.nav.pricing}</Link></li>
                <li><Link to="/register" className="hover:text-white transition-colors">{t.nav.trial}</Link></li>
              </ul>
            </div>
            <div>
              <div className="text-xs uppercase tracking-[0.2em] text-[#D4AF37] mb-4 font-bold">{t.footer.business}</div>
              <ul className="space-y-2.5 text-sm text-[#FDFBF9]/70">
                <li>{lang === "es" ? "Salones" : "Salons"}</li><li>{lang === "es" ? "Barberías" : "Barbershops"}</li><li>{lang === "es" ? "Spa y Bienestar" : "Spa & Wellness"}</li><li>{lang === "es" ? "Estudios de Uñas" : "Nail Studios"}</li>
              </ul>
            </div>
            <div>
              <div className="text-xs uppercase tracking-[0.2em] text-[#D4AF37] mb-4 font-bold">{t.footer.company}</div>
              <ul className="space-y-2.5 text-sm text-[#FDFBF9]/70">
                <li>{lang === "es" ? "Nosotros" : "About"}</li><li>{t.cta.demo}</li><li>{lang === "es" ? "Contacto" : "Contact"}</li><li>{lang === "es" ? "Privacidad" : "Privacy"}</li>
              </ul>
            </div>
          </div>
        </div>
        <div className="pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <div className="font-display font-extrabold text-5xl sm:text-7xl tracking-tighter text-[#FDFBF9]/8 select-none">BellaOS</div>
          <p className="text-xs text-[#FDFBF9]/40">© {new Date().getFullYear()} BellaOS · {t.footer.rights}</p>
        </div>
      </div>
    </footer>
  );
}
